import { sortBy } from 'lodash';
import { createSelector } from 'reselect';
import findWhere from 'selectors/findWhere';

const sitesModels = state => state.sites.models;
const currentSiteId = (state, ownProps) => ownProps.siteId;

export const organizationSites = createSelector(
    [sitesModels, currentSiteId],
    (sitesModels, currentSiteId) => {
        const sites = Object.values(sitesModels).filter(site =>
            site.organization_id === sitesModels[currentSiteId].organization_id
        );

        return sortBy(sites, 'name');
    }
);

const installationZones = state => state.installationZones.models; // or just `state.installationZones`

export const selectSiteInstallationZones = siteId => createSelector(
    [installationZones],
    zones => findWhere(Object.values(zones), { site_id: siteId })
);
